var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 20,
    viewBox: "0 0 512 512",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#347fb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211 166c0-41.353-33.647-75-75-75s-75 33.647-75 75 33.647 76 75 76 75-34.647 75-76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 392h-15c-8.284 0-15 6.714-15 15v30c0 8.284 6.716 15 15 15h15c16.569 0 30-13.433 30-30 0-16.569-13.431-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.3 512 9.901-30h-19.201c-16.199 0-31.5-3.6-45-10.501v25.501c0 8.399 6.599 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 451.99h29.399c-1.225 3.71 18.757-56.828 19.801-59.99h-49.2c-8.401 0-15-6.601-15-15v-60c0-8.401 6.599-15 15-15s15 6.599 15 15v44.99h44.099c-1.064 3.155 15.738-46.636 16.802-49.791 1.8-5.999 7.5-10.199 14.099-10.199h103.5c-6.901-34.2-37.2-60-73.5-60h-120c-41.525 0-76 33.655-76 75v60c0 42.902 36.826 74.99 76 74.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.993 332h-99.183l-60.004 180h109.194c6.453 0 12.182-4.129 14.224-10.252l6.883-20.647c-20.567-4.142-36.107-22.332-36.107-44.101v-30c0-24.814 20.186-45 45-45h15c5.24 0 10.237.89 15.086 2.157l4.138-12.415c3.238-9.711-3.991-19.742-14.231-19.742z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 0h-181c-24.814 0-45 20.186-45 45v121c0 24.814 20.186 46 45 46h15v45c0 6.064 3.647 11.543 9.258 13.857 5.533 2.309 12.023 1.071 16.348-3.252l55.605-55.605h84.789c24.814 0 45-21.186 45-46v-121c0-24.814-20.186-45-45-45zm-50.395 101.605-45 45c-2.93 2.93-6.768 4.395-10.605 4.395s-7.676-1.465-10.605-4.395l-22.5-22.5c-5.859-5.859-5.859-15.352 0-21.211s15.352-5.859 21.211 0l11.894 11.895 34.395-34.395c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352-.001 21.211z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyor);
export default __webpack_public_path__ + "static/media/surveyor.c3bcd0f89e86279047aae89099f262e9.svg";
export { ForwardRef as ReactComponent };